import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import SFImage, { anchorPoints } from "../SFImage";
import getClassNameFactory from "@wel-ui/utility-class-names";

import "./SFPoster.css";

import { PoseGroup } from "react-pose";
import { CrossFade } from "../../animations";

const SFPoster = ({
  alignBottom,
  children,
  height,
  imageAnchor,
  imageInlineAtNarrow,
  imageOverlay,
  imageSrc,
  imageSrcSet,
  share
}) => {
  const getClassName = getClassNameFactory(SFPoster.displayName);
  const imageProps = {
    anchor: imageAnchor,
    overlay: imageOverlay,
    src: imageSrc,
    srcSet: imageSrcSet
  };
  const image = (
    <SFImage
      alt=""
      fit="cover"
      sizes={SFImage.sizes.edgeToEdge}
      {...imageProps}
    />
  );

  return (
    <div
      className={getClassName({
        modifiers: classNames(alignBottom && "alignBottom", height)
      })}
    >
      {imageInlineAtNarrow ? (
        <div className={getClassName({ descendantName: "imageWrapper" })}>
          <PoseGroup>
            <CrossFade key={imageProps.src || imageProps.srcSet}>
              <div className={getClassName({ descendantName: "image" })}>
                {image}
              </div>
            </CrossFade>
          </PoseGroup>
        </div>
      ) : (
        <PoseGroup>
          <CrossFade key={imageProps.src || imageProps.srcSet}>
            <div className={getClassName({ descendantName: "image" })}>
              {image}
            </div>
          </CrossFade>
        </PoseGroup>
      )}
      <div className={getClassName({ descendantName: "content" })}>
        <div className={getClassName({ descendantName: "contentInner" })}>
          {children}
        </div>
        {share && (
          <div className={getClassName({ descendantName: "share" })}>
            {share}
          </div>
        )}
      </div>
    </div>
  );
};

SFPoster.displayName = "SFPoster";

SFPoster.heights = ["xs", "s", "m", "l"];

SFPoster.propTypes = {
  /**
   * Align content to bottom of Poster
   */
  alignBottom: PropTypes.bool,
  /**
   * Markup elements or components to render on Poster (usually a single Grid)
   */
  children: PropTypes.node,
  /**
   * T-shirt-sized (minimum) height of Poster
   */
  height: PropTypes.oneOf(SFPoster.heights),
  /**
   * Anchor point for Poster image
   */
  imageAnchor: PropTypes.oneOf(anchorPoints),
  /**
   * Optionally split Poster image above the content at narrow viewport
   */
  imageInlineAtNarrow: PropTypes.bool,
  /**
   * Apply an overlay to the Poster image, e.g. a scrim gradient for text
   * legibility. Should not be used if the image has a rasterized overlay.
   */
  imageOverlay: PropTypes.oneOf(SFImage.overlays),
  /**
   * Poster image `src`. Used if srcSet is not defined, or as a fallback.
   */
  imageSrc: PropTypes.string.isRequired,
  /**
   * Comma-separated list indicating a set of possible Poster image sources
   * for the user agent to use at different screen sizes
   */
  imageSrcSet: PropTypes.string,
  /**
   * Component (i.e. SocialDropdown) for sharing the page url
   */
  share: PropTypes.node
};

export default SFPoster;



// WEBPACK FOOTER //
// ./js/components/SFPoster/SFPoster.js